export function getHostFromURL(): string {
  return window.location.hostname;
}

export function getHostPrefix(fullHost = getHostFromURL()): string {
  const hostPrefix = fullHost.split('-') && fullHost.split('-')[0];
  return hostPrefix;
}

// Visual previews are available only on a local development server.
export function getThemeHostPrefix(
  hostname = window.location.hostname,
  search = window.location.search,
  development = import.meta.env.DEV,
): string {
  const hostPrefix = getHostPrefix(hostname);
  if (!development || !['localhost', '127.0.0.1', '[::1]'].includes(hostname)) {
    return hostPrefix;
  }

  return new URLSearchParams(search).get('theme') || hostPrefix;
}

